const mergeRefs = (...refs) => {
    return (value) => {
        refs.filter(Boolean).forEach(ref => {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref && typeof ref === 'object') {
                ref.current = value;
            }
        });
    };
};
export { mergeRefs };
